import { model as i18n } from '!/i18n'
import { createEffect, createStore, sample, type Effect } from 'effector'
import {
  type IAuthorizePaymentData,
  type IAuthorizePaymentResponse,
} from '../../index.h'
import { createPaymentAsync, parseErrors } from '../../lib'
import { $authorizeErrors } from '../stores'

export const $actualAuthorizeCreditCardData =
  createStore<IAuthorizePaymentResponse | null>(null)

export const sendPaymentDataToAuthorizeFx: Effect<
  IAuthorizePaymentData,
  IAuthorizePaymentResponse,
  Omit<IAuthorizePaymentResponse, 'opaqueData'>
> = createEffect<
  IAuthorizePaymentData,
  IAuthorizePaymentResponse,
  Omit<IAuthorizePaymentResponse, 'opaqueData'>
>(createPaymentAsync)

sample({
  clock: sendPaymentDataToAuthorizeFx.failData,
  source: i18n.$t,
  fn: parseErrors,
  target: $authorizeErrors,
})

sample({
  clock: sendPaymentDataToAuthorizeFx.doneData,
  target: $actualAuthorizeCreditCardData,
})
